import {mostrarMensajeErrorCatch, mostrarMensajeExitoso} from '../../mixins/mensajes';

const state = {
    catUnidades: {},
    catGeocercas: {},
    catTotal: {},
    
}
  
const mutations =  {
    setearCatalogoUnidades(state, datosObtenidos){
        state.catUnidades = datosObtenidos;
    },
    
    setearCatalogoGeocercas(state, datosObtenidos){
        state.catGeocercas = datosObtenidos;
    },
    
    setearCatalogoTotal(state, datosObtenidos){
        state.catTotal = datosObtenidos;
    },

}

const actions = {
    obtenerUnidades({commit, rootState}){
        rootState.cargando = true;
        axios.get(`${url}devices`)
            .then(response => {
                commit('setearCatalogoUnidades', response.data);
                rootState.cargando = false;
                //console.log(data.datos);
            })
            .catch(error => {
                mostrarMensajeErrorCatch('No se cargo el catálogo de unidades');
                rootState.cargando = false;
            })
    },
    
     obtenerGeocercas({commit, rootState}){
        rootState.cargando = true;
        axios.get('http://www.trukmen.com:4000/api/geofences')
            .then(response => {
                commit('setearCatalogoGeocercas', response.data);
                rootState.cargando = false;
                //console.log(data.datos);
            })
            .catch(error => {
                mostrarMensajeErrorCatch('No se cargo el catálogo de geocercas');
                rootState.cargando = false;
            })
    },
    
     obtenerTotal({commit, rootState}){
        rootState.cargando = true;
        axios.get(`${url2}numerogps`,{headers: {'content-type' : 'application/json'}})
        
            .then(response => {
                commit('setearCatalogoTotal', response.data.numerogps);
                rootState.cargando = false;
                console.log(response.data);
            })
            .catch(error => {
                mostrarMensajeErrorCatch('No se cargo el numero total de Unidades');
                rootState.cargando = false;
            })
    },
    
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}